import { LanguagesGridView } from '~/components/system/languages';
import { PageContainer } from '~/components/page-container';

export function Languages() {
	return (
		<PageContainer>
			<LanguagesGridView />
		</PageContainer>
	);
}
